// extracted by mini-css-extract-plugin
module.exports = {"flip":"IconUp_flip__jPiCm"};